<template>
  <button
    class="flex items-center justify-center mt-[24px] w-[118px] h-[40px] border-[#ECEBEB] border-solid border-[1.5px] rounded-[100px]"
    @click="share()"
  >
    <ShareIcon fill="currentColor" />
    <p class="ml-[8px] text-[1rem] leading-[1.5rem] font-semibold">Share</p>
  </button>
</template>

<script>
import { Share } from '@capacitor/share';
import ShareIcon from '../../../public/assets/icons/library/ShareIcon.vue';

export default {
  components: {
    ShareIcon,
  },
  props: {
    eventName: {
      type: String,
      default: '',
    },
    sharingUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    async share() {
      await Share.share({
        title: this.eventName,
        url: this.sharingUrl,
      });
    },
  },
};
</script>

<style></style>
